import React from "react";
import PropTypes from "prop-types";
import { InfoPanel } from "./InfoPanel";
import {
	cloudinarySourceSetAdapter,
	cloudinaryImageAdapter,
} from "../../sharedComponents/CloudinaryImageAdapter";

const InfoPanelConnector = ({ data: { members } }) => (
	<InfoPanel
		members={members.map(m => ({
			id: m.id,
			profile: {
				name: m.name,
				role: m.role,
				image: cloudinaryImageAdapter({
					cloudinaryImage: m.cloudinaryImage?.[0],
					maxWidth: 300,
				}),
				imageSrcSet: cloudinarySourceSetAdapter(m.imageAssets),
			},
			details: m.details,
			footer: m.footer,
		}))}
	/>
);

InfoPanelConnector.propTypes = {
	data: PropTypes.object.isRequired,
};

export default InfoPanelConnector;
export { InfoPanelConnector };
